import Helper from "./Helper";
import Sticky from '../../../node_modules/sticky-js';

class FrontPageAni {
  constructor(config = {}) {
    const { keyfigures, horizontalImageWrapper, horizontalImageItem, colorContainer, headerText, horizontalImage, breakpoint } = config;

    if(Helper.hasClass(document.querySelector('body'),'home')){
      this.keyfigures = document.querySelectorAll(keyfigures);
      this.keyfiguresArray = Array.prototype.slice.call(this.keyfigures);
      this.scrollPosFirst = {};
      this.scrollPosFirst.text = [];
      this.scrollPosFirst.img = [];
      this.initialScrollPosition = [];
      this.breakpoint = breakpoint;
      this.lastScrollTop = 0;

      //initial the pixels for parallax.
      this.translateNrImg = 3;
      this.translateNrText = 6;
      //pixels for paralax on mobile
      if(!this.checkScreenSize()){
        this.translateNrImg = 1;
        this.translateNrText = 0;
      }

      // intialize keyfigure positions (used to see if scrolled up or down)
      this.keyfiguresArray.forEach(() => {
        this.initialScrollPosition.push(false);
        this.scrollPosFirst.text.push(0);
        this.scrollPosFirst.img.push(0);
      });

      this.horizontalImageWrapperString = horizontalImageWrapper;
      this.horizontalImageWrapper = document.querySelector(horizontalImageWrapper);
      this.horizontalImage = document.querySelector(horizontalImage);
      this.horizontalImageItem = document.querySelectorAll(horizontalImageItem);
      this.horizontalImageItemArray = Array.prototype.slice.call(this.horizontalImageItem);
      this.imageWrapperWidth = 0;

      this.theoldwidth = 'undefined';

      this.colorContainer = document.querySelector(colorContainer);

      this.header = document.querySelector('header');
      this.headerText = document.querySelector(headerText);
      if(this.headerTextWidth){
        this.headerTextWidth = document.querySelector(headerText).getBoundingClientRect().width;
      }

      this.continueScrolling = true;
      this.horizontalScrollNr = 0;

      this.lastScrollPos = 0;
      this.scrollDirection = '';

      //add sticky-attributes for the sticky-js library
      if(this.colorContainer){
        this.colorContainerInner = this.colorContainer.querySelector('.ns-color-container__content');

        this.colorContainer.setAttribute('data-sticky-container', '');
        this.headerHeight = this.header.getBoundingClientRect().height;

        this.colorContainerInner.setAttribute('data-margin-top', this.headerHeight);
        this.colorContainerInner.setAttribute('data-sticky-class', 'is-stuck');

        //add initial position for Slider-Container (has to start on same left-point as the title)
        this.initialLeftPositionOfSlider = document.querySelector('.ns-header__text').getBoundingClientRect().left;

        this.horizontalImage.style.left = this.initialLeftPositionOfSlider + 'px';

        this.colorContainerInnerPosTop = this.colorContainerInner.getBoundingClientRect().top + window.scrollY + this.initialLeftPositionOfSlider;

        this.bindEventsOnLoad();
      }
    }
  }

  registerScroll() {
    window.addEventListener("scroll", e => {
      let st = window.pageYOffset || document.documentElement.scrollTop;

      if (st > this.lastScrollTop){
        this.scrollDirection = 'down';
      } else {
        this.scrollDirection = 'up';
      }

      this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

      this.keyfiguresArray.forEach((element, index) => {
        this.handleScroll(element, e, index, this.scrollDirection);
      });

      if(Helper.hasClass(this.colorContainerInner, 'is-stuck')){
        this.continueScrolling = false;
        this.horizontalScrollNr = this.offset(this.colorContainerInner).top - this.colorContainerInnerPosTop;
      }

      if(!this.continueScrolling){
        this.handleHorizontalScroll(this.horizontalImage, this.horizontalScrollNr);
      }
    });
  }

  bindEventsOnLoad(){
    if(Helper.loadImagesInContainer(this.horizontalImageWrapperString)){
      this.addWithAndHeight(this.horizontalImageItemArray);
    };

    this.keyfiguresArray.forEach((element) => {
      if (Helper.isInViewport(element)) {
        Helper.addClass(element, "is-in-viewport");
        Helper.removeClass(element, "is-not-in-viewport");
      } else {
        Helper.removeClass(element, "is-in-viewport");
        Helper.addClass(element, "is-not-in-viewport");
      }
    });
  }

  offset(el) {
    const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  }

  // handle scrolling of keyfigure
  handleScroll(element, e, ind, scrollDirection) {
    let scrollTop = e.currentTarget.pageYOffset;

    if(this.continueScrolling){
      this.lastScrollPos = scrollTop;
    }

    if (Helper.isInViewport(element)) {
      this.initialScrollPosition[ind] = true;
      Helper.addClass(element, "is-in-viewport");
      Helper.removeClass(element, "is-not-in-viewport");

      this.addTransform(element.querySelector('.ns-keyfigure__text'), this.scrollPosFirst.text[ind]);
      this.addTransform(element.querySelector('.ns-keyfigure__img'), this.scrollPosFirst.img[ind]);
    } else {
      this.initialScrollPosition[ind] = false;
      Helper.removeClass(element, "is-in-viewport");
      Helper.addClass(element, "is-not-in-viewport");
    }

    if(this.initialScrollPosition[ind] && scrollDirection === 'down'){
      this.scrollPosFirst.text[ind] = this.scrollPosFirst.text[ind] - this.translateNrText;
      this.scrollPosFirst.img[ind] = this.scrollPosFirst.img[ind] - this.translateNrImg;
    }else if(this.initialScrollPosition[ind] && scrollDirection === 'up'){
      this.scrollPosFirst.text[ind] = this.scrollPosFirst.text[ind] + this.translateNrText;
      this.scrollPosFirst.img[ind] = this.scrollPosFirst.img[ind] + this.translateNrImg;
    }
  }

  addWithAndHeight(children){
    //get image width, need to add this in scroll handle
    let thewidth = 0;
    let allChildrenCounted = false;
    children.forEach((item, index)=>{
      thewidth += item.offsetWidth;
      //set variable to true, when all children are added to the full with, so he ends the function only, when this is set to true
      allChildrenCounted = (item.offsetWidth > 0 && index === children.length - 1) ? true : false;
    });
    //when
    if(thewidth !== 0 && thewidth == this.theoldwidth && allChildrenCounted === true){
      this.imageWrapperWidth = (thewidth+10); //adding the width of each element
      this.horizontalImage.style.width =  this.imageWrapperWidth + 'px';
      //scroll size on screen
      // if(this.checkScreenSize()){
        this.colorContainer.style.height = (this.imageWrapperWidth - this.initialLeftPositionOfSlider) + 'px';
      // }else{
        //... on mobile
        // this.colorContainer.style.height = (this.imageWrapperWidth + 50) + 'px';
      // }
      this.registerScroll();
      new Sticky('.ns-color-container__content');
    } else{
      setTimeout(() => {
        this.theoldwidth = thewidth;
        this.addWithAndHeight(children);
      }, 500);
    }
  }

  handleHorizontalScroll(element, nr){
    element.style.left = -nr + 'px';
  }

  addTransform(el, transNr){
    el.style.transform = 'translateY('+ transNr +'px)';
  }

  checkScreenSize(){
    if(window.matchMedia('(' + this.breakpoint + ')').matches){
      return true;
    }
    return false;
  }
}


export default FrontPageAni;
